import { deepEqual } from "fast-equals";

import { clearStorage, setStorage, StorageKey } from "@/constants/storage";
import { hasData } from "@/store/apiRequestStatusMachine";
import type { AppStartListening } from "@/store/listenerMiddleware";

export const addUserListeneres = (startListening: AppStartListening) => {
  startListening({
    predicate: (_action, currentState, previousState) =>
      !deepEqual(previousState.user.userData, currentState.user.userData),

    effect: (_action, { getState }) => {
      const userData = getState().user.userData;

      if (hasData(userData)) {
        setStorage(StorageKey.USER, userData.state);
      } else {
        clearStorage(StorageKey.USER);
      }
    },
  });
};
